import React, { Component } from "react";
import {FaFacebookF , FaYoutube} from "react-icons/fa";
import { Translation } from 'react-i18next';

const SocialShare = [
    {Social: <FaYoutube /> , link: 'https://www.youtube.com/channel/UCQxWQycVREjRt5O3Yc5cQ0g'},
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/doclabinhduong.np'},  
    {Social: <FaYoutube /> , link: 'https://www.youtube.com/channel/UCSVUw-eq8DkEh0rN4aOIm9w'},
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/congtydoclavietnam'},  
    {Social: <FaYoutube /> , link: 'https://www.youtube.com/channel/UClAN8--dF1vOr8pJ6zPaN1g'},
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/34hemla.np'},    
]
class Footer extends Component{
    render(){
        return(
            <React.Fragment>
                <footer className="footer-area">
                    <div className="footer-wrapper">
                        <div className="row align-items-end row--0">
                            <div className="col-lg-6">
                                <div className="footer-left">
                                    <div className="inner">
                                        <span><Translation>{(t, { i18n }) => t('interactMil')}</Translation></span>
                                        <h2><Translation>{(t, { i18n }) => t('contacth2')}</Translation></h2>
                                        <a className="rn-button-style--2" href="/#contact">
                                            <span><Translation>{(t, { i18n }) => t('contact')}</Translation></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="footer-right" data-black-overlay="6">
                                    <div className="row">
                                         {/* Start Single Widget  */}
                                         <div className="col-lg-6 col-sm-6 col-12">
                                            <div className="footer-link" style={{marginBottom:50}}>
                                                <h4><Translation>{(t, { i18n }) => t('adr')}</Translation></h4>
                                                <ul className="ft-link">
                                                    <li><a href="https://goo.gl/maps/su46vh4WXC9Soy9c7" target="_blank" rel="noopener noreferrer"><Translation>{(t, { i18n }) => t('adrLine0')}</Translation></a></li>
                                                    <li><a href="https://goo.gl/maps/su46vh4WXC9Soy9c7" target="_blank" rel="noopener noreferrer"><Translation>{(t, { i18n }) => t('adrLine')}</Translation></a></li>                                                    
                                                </ul>
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}

                                        {/* Start Single Widget  */}
                                        <div className="col-lg-6 col-sm-6 col-12">
                                            <div className="footer-link" style={{marginBottom:50}}>
                                                <h4><Translation>{(t, { i18n }) => t('tel')}</Translation></h4>
                                                <ul className="ft-link">
                                                    <li><a href="/"><Translation>{(t, { i18n }) => t('biz')}</Translation>:</a> </li>
                                                    <li><a href="/">+084 0903 026 786</a> </li>
                                                    <li><a href="/"><Translation>{(t, { i18n }) => t('contactS')}</Translation>:</a> </li>
                                                    <li><a href="/">+084 82 614 2777 </a> </li>
                                                </ul>
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}                                       

                                        {/* Start Single Widget  */}
                                        <div className="col-lg-6 col-sm-6 col-12">
                                            <div className="footer-link" style={{marginBottom:50}}>
                                                <h4><Translation>{(t, { i18n }) => t('connect')}</Translation></h4>
                                                <ul className="ft-link">
                                                    <li><a href="/#service"><Translation>{(t, { i18n }) => t('service')}</Translation></a></li>
                                                    <li><a href="/about"><Translation>{(t, { i18n }) => t('about')}</Translation></a></li>
                                                    <li><a href="/news"><Translation>{(t, { i18n }) => t('news')}</Translation></a></li>                                                   
                                                </ul>
                                            </div>
                                            <div className="social-share-inner">
                                                    <ul className="social-share social-style--2 d-flex justify-content-start liststyle mt--15">
                                                        {SocialShare.map((val , i) => (
                                                            <li key={i}><a href={`${val.link}`} target="_blank" rel="noopener noreferrer">{val.Social}</a></li>
                                                        ))}
                                                    </ul>
                                        </div> 
                                        </div>
                                        {/* End Single Widget  */}
                                                                              
                                        {/* Start Single Widget  */}
                                        <div className="col-lg-6 col-sm-6 col-12 mt_mobile--30">
                                            <div className="footer-link">
                                                <h4><Translation>{(t, { i18n }) => t('email')}</Translation></h4>
                                                <ul className="ft-link">
                                                    <li><a href="mailto:lienhe@doclavietnam.com"><Translation>{(t, { i18n }) => t('contactS')}</Translation>: lienhe@doclavietnam.com</a></li>
                                                    <li><a href="mailto:kinhdoanh@doclavietnam.com"><Translation>{(t, { i18n }) => t('biz')}</Translation>: kinhdoanh@doclavietnam.com</a></li>
                                                </ul>

                                               
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}
                                        
                                        <div className="col-lg-12">
                                            <div className="copyright-text">
                                                <p>Copyright © 2021 ExtraOrdinary Viet Nam. All Rights Reserved.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </React.Fragment>
        )
    }
}
export default Footer;